import type { ChainMetadata } from '@polaris/core/models'
import { useQuery } from '@tanstack/react-query'
import { chainsQuery, preferredEndpointQuery } from '@/src/queries/keys/chains'

/** QueryResult.data: Chain ID => Chain */
export const useSupportedChainsMap = () =>
  useQuery({
    ...chainsQuery(),
    select: (data) =>
      data?.chains.reduce((map, chain) => {
        map.set(chain.chain_id, chain)
        return map
      }, new Map<string, ChainMetadata>()),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })

export const useSupportedChains = () =>
  useQuery({
    ...chainsQuery(),
    select: (data) => data?.chains,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })

/**
 * Hook to get preferred RPC endpoint for a chain
 * Returns the preferred endpoint record with URL and optional headers
 */
export const usePreferredEndpoint = (chainId: string) =>
  useQuery(preferredEndpointQuery(chainId))
